import { render, staticRenderFns } from "./payFeeCoupon.vue?vue&type=template&id=20ab59e9&scoped=true"
import script from "./payFeeCoupon.vue?vue&type=script&lang=js"
export * from "./payFeeCoupon.vue?vue&type=script&lang=js"
import style0 from "./payFeeCoupon.vue?vue&type=style&index=0&id=20ab59e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ab59e9",
  null
  
)

export default component.exports